export default __webpack_public_path__ + "svg/calendar/2025/9/octubre.svg?8beab4cf";